import React from 'react';
import { Spinner } from 'react-bootstrap';

/**
 * Loader component for displaying loading states
 */
const Loader = () => {
  return (
    <Spinner
      animation="border"
      role="status"
      style={{
        width: '50px',
        height: '50px',
        margin: 'auto',
        display: 'block',
      }}
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
};

// Export the component as default
export default Loader;
